import { createAction, props } from '@ngrx/store';

export const packageTableRequest = createAction(
    '[Package Table] Load Request'
);

export const packageTableSuccess = createAction(
    '[Package Table] Load Response',
    props<{ totalCount: number, page: any }>()
);

export const packageTableFailure = createAction(
    '[Package Table] Load Failure'
);

export const packageTableChangePage = createAction(
    '[Package Table] Change Page',
    props<{ pageNumber: number, itemsPerPage: number }>()
);

export const packageTableChangeQuery = createAction(
    '[Package Table] Change Filter',
    props<{ query: any }>()
);

export const packageTableSort = createAction(
    '[Package Table] Change Sort Column',
    props<{ id: string, descending: boolean }>()
);

export const packageTableSetSelection = createAction(
    '[Package Table] Set Selection',
    props<{ selection: string[] }>()
);

export const packageTableMasterToggle = createAction(
    '[Package Table] Master Selection Toggle'
);

export const packageTableToggle = createAction(
    '[Package Table] Toggle Selection',
    props<{ id: string }>()
);

export const packageTableAddAssist = createAction(
    '[Package Table] Add Filter Assist',
    props<{ id: string, parameter: any }>()
);

export const packageTableRemoveAssist = createAction(
    '[Package Table] Remove Filter Assist',
    props<{ id: string }>()
);

